"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
(function (Drupal, once, drupalSettings) {
  'use strict';

  /** Store API paths */
  var apiPaths = {
    states: '/ikn-custom/find-dentist/options/states',
    plansBase: '/ikn-custom/find-dentist/options/benefit-plans'
  };

  /** Store DOM selectors */
  var selectors = {
    stateSelect: 'select[name="state"]',
    benefitPlanSelect: 'select[name="benefit_plan"]'
  };

  /** Store shared UI values */
  var uiText = {
    emptyValue: '0'
  };

  /** Store ready event name */
  var optionsReadyEventName = 'ikn:optionsHydrated';

  /** Track active plans request */
  var activePlansRequestController = null;

  /** Read defaults from settings */
  function readDefaultsFromSettings() {
    var _drupalSettings$ikn_c, _drupalSettings$ikn_c2, _settings$stateDefaul, _settings$benefitPlan;
    var settings = (_drupalSettings$ikn_c = drupalSettings === null || drupalSettings === void 0 || (_drupalSettings$ikn_c2 = drupalSettings.ikn_custom) === null || _drupalSettings$ikn_c2 === void 0 ? void 0 : _drupalSettings$ikn_c2.findDentist) !== null && _drupalSettings$ikn_c !== void 0 ? _drupalSettings$ikn_c : {};
    return {
      state: String((_settings$stateDefaul = settings.stateDefault) !== null && _settings$stateDefaul !== void 0 ? _settings$stateDefaul : uiText.emptyValue),
      plan: String((_settings$benefitPlan = settings.benefitPlanDefault) !== null && _settings$benefitPlan !== void 0 ? _settings$benefitPlan : uiText.emptyValue)
    };
  }

  /** Pick initial selection */
  function pickInitialSelection() {
    var fromSettings = readDefaultsFromSettings();
    return {
      state: fromSettings.state,
      plan: fromSettings.plan,
      source: 'settings'
    };
  }

  /** Read state placeholder */
  function readStatePlaceholder(stateEl) {
    var _stateEl$dataset$plac, _stateEl$dataset;
    return (_stateEl$dataset$plac = stateEl === null || stateEl === void 0 || (_stateEl$dataset = stateEl.dataset) === null || _stateEl$dataset === void 0 ? void 0 : _stateEl$dataset.placeholder) !== null && _stateEl$dataset$plac !== void 0 ? _stateEl$dataset$plac : 'Select a State';
  }

  /** Read no-state plan placeholder */
  function readPlanNoStatePlaceholder(planEl) {
    var _planEl$dataset$place, _planEl$dataset;
    return (_planEl$dataset$place = planEl === null || planEl === void 0 || (_planEl$dataset = planEl.dataset) === null || _planEl$dataset === void 0 ? void 0 : _planEl$dataset.placeholderNoState) !== null && _planEl$dataset$place !== void 0 ? _planEl$dataset$place : 'Select a State First';
  }

  /** Read pick-plan placeholder */
  function readPlanPickPlaceholder(planEl) {
    var _planEl$dataset$place2, _planEl$dataset2;
    return (_planEl$dataset$place2 = planEl === null || planEl === void 0 || (_planEl$dataset2 = planEl.dataset) === null || _planEl$dataset2 === void 0 ? void 0 : _planEl$dataset2.placeholderPick) !== null && _planEl$dataset$place2 !== void 0 ? _planEl$dataset$place2 : 'Please Select a Plan';
  }

  /** Read no-plans placeholder */
  function readPlanNonePlaceholder(planEl) {
    var _planEl$dataset$place3, _planEl$dataset3;
    return (_planEl$dataset$place3 = planEl === null || planEl === void 0 || (_planEl$dataset3 = planEl.dataset) === null || _planEl$dataset3 === void 0 ? void 0 : _planEl$dataset3.placeholderNone) !== null && _planEl$dataset$place3 !== void 0 ? _planEl$dataset$place3 : 'No Plans Found';
  }

  /** Fetch JSON from API */
  function fetchJson(_x) {
    return _fetchJson.apply(this, arguments);
  }
  /** Build plans API URL */
  function _fetchJson() {
    _fetchJson = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(url) {
      var _ref8,
        signal,
        response,
        _args2 = arguments;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _ref8 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, signal = _ref8.signal;
            _context2.n = 1;
            return fetch(url, {
              method: 'GET',
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json'
              },
              signal: signal
            });
          case 1:
            response = _context2.v;
            if (response.ok) {
              _context2.n = 2;
              break;
            }
            throw new Error("HTTP ".concat(response.status, " ").concat(response.statusText));
          case 2:
            return _context2.a(2, response.json());
        }
      }, _callee2);
    }));
    return _fetchJson.apply(this, arguments);
  }
  var buildPlansUrl = function buildPlansUrl(stateAbbr) {
    return "".concat(apiPaths.plansBase, "/").concat(encodeURIComponent(stateAbbr));
  };

  /** Read options map from payload */
  var getOptionsMap = function getOptionsMap(payload) {
    var options = payload === null || payload === void 0 ? void 0 : payload.options;
    return options && _typeof(options) === 'object' ? options : {};
  };

  /** Load state options */
  function loadStateOptions() {
    return _loadStateOptions.apply(this, arguments);
  }
  /** Load plan options for state */
  function _loadStateOptions() {
    _loadStateOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _t = getOptionsMap;
            _context3.n = 1;
            return fetchJson(apiPaths.states);
          case 1:
            return _context3.a(2, _t(_context3.v));
        }
      }, _callee3);
    }));
    return _loadStateOptions.apply(this, arguments);
  }
  function loadPlanOptionsForState(_x2) {
    return _loadPlanOptionsForState.apply(this, arguments);
  }
  /** Run async with fallback */
  function _loadPlanOptionsForState() {
    _loadPlanOptionsForState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(stateAbbr) {
      var payload;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            if (activePlansRequestController) {
              activePlansRequestController.abort();
            }
            activePlansRequestController = new AbortController();
            _context4.n = 1;
            return fetchJson(buildPlansUrl(stateAbbr), {
              signal: activePlansRequestController.signal
            });
          case 1:
            payload = _context4.v;
            return _context4.a(2, getOptionsMap(payload));
        }
      }, _callee4);
    }));
    return _loadPlanOptionsForState.apply(this, arguments);
  }
  function safeAsync(_x3, _x4) {
    return _safeAsync.apply(this, arguments);
  }
  /** Fetch plans safely */
  function _safeAsync() {
    _safeAsync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(fn, fallback) {
      var _t2;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            _context5.p = 0;
            _context5.n = 1;
            return fn();
          case 1:
            return _context5.a(2, _context5.v);
          case 2:
            _context5.p = 2;
            _t2 = _context5.v;
            if (!(_t2 && _t2.name === 'AbortError')) {
              _context5.n = 3;
              break;
            }
            return _context5.a(2, null);
          case 3:
            return _context5.a(2, fallback);
        }
      }, _callee5, null, [[0, 2]]);
    }));
    return _safeAsync.apply(this, arguments);
  }
  function fetchPlansForState(_x5) {
    return _fetchPlansForState.apply(this, arguments);
  }
  /** Clear select options */
  function _fetchPlansForState() {
    _fetchPlansForState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(state) {
      var plansMap;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _context6.n = 1;
            return safeAsync(function () {
              return loadPlanOptionsForState(state);
            }, {});
          case 1:
            plansMap = _context6.v;
            if (!(plansMap === null)) {
              _context6.n = 2;
              break;
            }
            return _context6.a(2, null);
          case 2:
            return _context6.a(2, plansMap);
        }
      }, _callee6);
    }));
    return _fetchPlansForState.apply(this, arguments);
  }
  function clearSelectOptions(selectEl) {
    selectEl.replaceChildren();
  }

  /** Add option to select */
  function addSelectOption(selectEl, value, label) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected;
    var optionEl = document.createElement('option');
    optionEl.value = String(value);
    optionEl.textContent = String(label);
    if (selected) {
      optionEl.selected = true;
    }
    selectEl.appendChild(optionEl);
  }

  /** Render state options */
  function renderStates(stateEl, statesMap, desiredState) {
    clearSelectOptions(stateEl);
    var wantedState = String(desiredState !== null && desiredState !== void 0 ? desiredState : uiText.emptyValue);
    var hasWantedState = wantedState !== uiText.emptyValue && Object.prototype.hasOwnProperty.call(statesMap, wantedState);
    addSelectOption(stateEl, uiText.emptyValue, readStatePlaceholder(stateEl), {
      selected: !hasWantedState
    });
    for (var _i = 0, _Object$entries = Object.entries(statesMap); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        value = _Object$entries$_i[0],
        label = _Object$entries$_i[1];
      var stateValue = String(value);
      if (stateValue === uiText.emptyValue) {
        continue;
      }
      addSelectOption(stateEl, stateValue, label, {
        selected: hasWantedState && stateValue === wantedState
      });
    }
    stateEl.value = hasWantedState ? wantedState : uiText.emptyValue;
  }

  /** Render plan placeholder */
  function renderPlanPlaceholder(planEl, label) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? true : _ref2$disabled;
    clearSelectOptions(planEl);
    addSelectOption(planEl, uiText.emptyValue, label, {
      selected: true
    });
    planEl.value = uiText.emptyValue;
    planEl.disabled = disabled;
  }

  /** Render plan options */
  function renderPlans(planEl, plansMap, desiredPlan) {
    clearSelectOptions(planEl);
    var wantedPlan = String(desiredPlan !== null && desiredPlan !== void 0 ? desiredPlan : uiText.emptyValue);
    var hasWantedPlan = wantedPlan !== uiText.emptyValue && Object.prototype.hasOwnProperty.call(plansMap, wantedPlan);
    addSelectOption(planEl, uiText.emptyValue, readPlanPickPlaceholder(planEl), {
      selected: !hasWantedPlan
    });
    for (var _i2 = 0, _Object$entries2 = Object.entries(plansMap); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        value = _Object$entries2$_i[0],
        label = _Object$entries2$_i[1];
      var planValue = String(value);
      if (planValue === uiText.emptyValue) {
        continue;
      }
      addSelectOption(planEl, planValue, label, {
        selected: hasWantedPlan && planValue === wantedPlan
      });
    }
    var planKeys = Object.keys(plansMap || {}).filter(function (key) {
      return String(key) !== uiText.emptyValue;
    });
    var onlyOneRealPlan = planKeys.length === 1;
    if (onlyOneRealPlan && !hasWantedPlan) {
      planEl.value = String(planKeys[0]);
    } else {
      planEl.value = hasWantedPlan ? wantedPlan : uiText.emptyValue;
    }
    planEl.disabled = false;
  }

  /** Emit options ready event */
  function emitOptionsReady(formEl) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$state = _ref3.state,
      state = _ref3$state === void 0 ? uiText.emptyValue : _ref3$state,
      _ref3$plan = _ref3.plan,
      plan = _ref3$plan === void 0 ? uiText.emptyValue : _ref3$plan,
      _ref3$source = _ref3.source,
      source = _ref3$source === void 0 ? 'unknown' : _ref3$source;
    if (!formEl) {
      return;
    }
    formEl.dispatchEvent(new CustomEvent(optionsReadyEventName, {
      bubbles: true,
      detail: {
        state: String(state),
        benefitPlan: String(plan),
        source: source
      }
    }));
  }

  /** Load and render plans */
  function loadPlansForState(_x6) {
    return _loadPlansForState.apply(this, arguments);
  }
  /** Initialize state and plan selects */
  function _loadPlansForState() {
    _loadPlansForState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref4) {
      var formEl, planEl, state, desiredPlan, source, selectedState, plansMap, hasAnyPlans;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            formEl = _ref4.formEl, planEl = _ref4.planEl, state = _ref4.state, desiredPlan = _ref4.desiredPlan, source = _ref4.source;
            selectedState = String(state !== null && state !== void 0 ? state : uiText.emptyValue);
            if (!(!selectedState || selectedState === uiText.emptyValue)) {
              _context7.n = 1;
              break;
            }
            renderPlanPlaceholder(planEl, readPlanNoStatePlaceholder(planEl));
            emitOptionsReady(formEl, {
              state: uiText.emptyValue,
              plan: uiText.emptyValue,
              source: source
            });
            return _context7.a(2);
          case 1:
            renderPlanPlaceholder(planEl, readPlanPickPlaceholder(planEl), {
              disabled: true
            });
            _context7.n = 2;
            return fetchPlansForState(selectedState);
          case 2:
            plansMap = _context7.v;
            if (!(plansMap === null)) {
              _context7.n = 3;
              break;
            }
            return _context7.a(2);
          case 3:
            hasAnyPlans = Object.keys(plansMap).length > 0;
            if (hasAnyPlans) {
              _context7.n = 4;
              break;
            }
            renderPlanPlaceholder(planEl, readPlanNonePlaceholder(planEl));
            emitOptionsReady(formEl, {
              state: selectedState,
              plan: uiText.emptyValue,
              source: source
            });
            return _context7.a(2);
          case 4:
            renderPlans(planEl, plansMap, desiredPlan);
            emitOptionsReady(formEl, {
              state: selectedState,
              plan: planEl.value,
              source: source
            });
          case 5:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return _loadPlansForState.apply(this, arguments);
  }
  function initSelects(_x7) {
    return _initSelects.apply(this, arguments);
  }
  /** Bind state and plan events */
  function _initSelects() {
    _initSelects = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref5) {
      var _stateEl$value2;
      var formEl, stateEl, planEl, initialSelection, statesMap, finalState;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            formEl = _ref5.formEl, stateEl = _ref5.stateEl, planEl = _ref5.planEl;
            initialSelection = pickInitialSelection();
            if (!(stateEl.options.length <= 1)) {
              _context8.n = 2;
              break;
            }
            _context8.n = 1;
            return safeAsync(loadStateOptions, {});
          case 1:
            statesMap = _context8.v;
            renderStates(stateEl, statesMap, initialSelection.state);
            _context8.n = 3;
            break;
          case 2:
            if (initialSelection.state !== uiText.emptyValue) {
              stateEl.value = initialSelection.state;
            }
          case 3:
            finalState = String((_stateEl$value2 = stateEl.value) !== null && _stateEl$value2 !== void 0 ? _stateEl$value2 : uiText.emptyValue);
            _context8.n = 4;
            return loadPlansForState({
              formEl: formEl,
              planEl: planEl,
              state: finalState,
              desiredPlan: initialSelection.plan,
              source: initialSelection.source
            });
          case 4:
            return _context8.a(2);
        }
      }, _callee8);
    }));
    return _initSelects.apply(this, arguments);
  }
  function bindOptions(_ref6) {
    var _formEl$dataset;
    var formEl = _ref6.formEl,
      stateEl = _ref6.stateEl,
      planEl = _ref6.planEl;
    if ((formEl === null || formEl === void 0 || (_formEl$dataset = formEl.dataset) === null || _formEl$dataset === void 0 ? void 0 : _formEl$dataset.basicOptionsBound) === '1') {
      return;
    }
    formEl.dataset.basicOptionsBound = '1';
    stateEl.addEventListener('change', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _stateEl$value;
      var selectedState;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            selectedState = String((_stateEl$value = stateEl.value) !== null && _stateEl$value !== void 0 ? _stateEl$value : uiText.emptyValue);
            _context.n = 1;
            return loadPlansForState({
              formEl: formEl,
              planEl: planEl,
              state: selectedState,
              desiredPlan: uiText.emptyValue,
              source: 'user'
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    })));
    formEl.addEventListener('reset', function () {
      window.setTimeout(function () {
        stateEl.value = uiText.emptyValue;
        renderPlanPlaceholder(planEl, readPlanNoStatePlaceholder(planEl), {
          disabled: true
        });
        emitOptionsReady(formEl, {
          state: uiText.emptyValue,
          plan: uiText.emptyValue,
          source: 'reset'
        });
      }, 0);
    });
    initSelects({
      formEl: formEl,
      stateEl: stateEl,
      planEl: planEl
    })["catch"](function () {});
  }
  Drupal.behaviors.iknBasicOptions = {
    /** Attach basic options behavior */attach: function attach(context) {
      var stateEls = once('iknBasicStateOptions', selectors.stateSelect, context);
      stateEls.forEach(function (stateEl) {
        var formEl = stateEl.form || stateEl.closest('form');
        if (!formEl) {
          return;
        }
        var planEl = formEl.querySelector(selectors.benefitPlanSelect);
        if (!planEl) {
          return;
        }
        bindOptions({
          formEl: formEl,
          stateEl: stateEl,
          planEl: planEl
        });
      });
    }
  };
})(Drupal, once, drupalSettings);